<template>
  <div class="flex flex-col items-center">
    <h2 class="mb-[4px] text-[28px] font-semibold">扫码登录</h2>
    <p class="mb-6 text-base">请关注和鲸公众号完成登录</p>
    <div class="w-[200px] h-[200px]" :style="getCodeAsBackground">
      <div v-if="error" class="error-mask h-[200px]"></div>
      <div v-if="expired" class="expired-mask h-[200px] flex flex-col items-center justify-center">
        <div class="mb-4 w-[88px] h-[88px] rounded-full flex flex-col items-center bg-white cursor-pointer" @click="fetchQRCode">
          <span class="iconfont iconrefresh block w-full text-center leading-[88px] text-4xl"></span>
        </div>
        <p class="text-center font-semibold">二维码失效，点击刷新</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
// TODO vuex typings
// @ts-ignore
import { useStore } from 'vuex';
import axios from 'axios';
import useLoginCheck from '@/composables/login-check.ts';

const router = useRouter();
const store = useStore();

const error = ref(false);
const code = ref('');
const ticket = ref('');
const expiry = ref(0);
const expired = ref(false);
const scanned = ref(false);
const poller = ref<number | NodeJS.Timeout>(0);

const getCodeAsBackground = computed(() => {
  return {
    backgroundImage: `url(${encodeURI(code.value)})`,
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
  };
});

const fetchQRCode = async () => {
  const params = { type: 'LOGIN' };
  const { data } = await axios.get(`/api/wechatPublic/ticket`, { params });
  code.value = data?.QRcodeUrl;
  ticket.value = data?.ticket;
  expiry.value = data?.expire_seconds * 1000;
  expired.value = false;
  if (!ticket.value) {
    error.value = true;
    return;
  }
  setTimeout(() => {
    expired.value = true;
    if (poller.value) clearInterval(poller.value);
  }, expiry.value);
};

const fetchBindingStatus = async () => {
  const { data } = await axios.get(`/oauth/wechatPublic/${ticket.value}`);
  if (data?.oauth) {
    // 微信号未绑定和鲸账号
    // 更新 oauth state
    // 跳转到 OAuth
    store.commit('setOAuthState', data.oauth);
    router.push({ name: 'oauth' });
  } else {
    useLoginCheck();
  }
};

const fetchTicketStatus = async () => {
  if (scanned.value) return;
  try {
    const { data } = await axios.get(`/api/wechatPublic/ticketStatus/${ticket.value}`);
    scanned.value = Boolean(data?.status) || false;
  } catch (e: any) {
    error.value = true;
  }
};

onMounted(async () => {
  await fetchQRCode();
  if (expired.value) {
    await fetchQRCode();
  }
  if (!ticket.value) return;
  poller.value = setInterval(async () => {
    if (scanned.value) {
      fetchBindingStatus();
      clearInterval(poller.value);
    }
    await fetchTicketStatus();
  }, 1000);
});

onBeforeUnmount(() => {
  if (poller.value) clearInterval(poller.value);
});
</script>

<style lang="scss" scoped>
.error-mask {
  background-image: url('@/assets/login-page/wechat-error.png');
  background-repeat: no-repeat;
  background-size: cover;
}
.expired-mask {
  background-color: rgba($white, 0.9);
}
</style>
